<template>
  <div
    id="ld-content"
    class="not-support"
  >
    <p class="color-section marb24">
      {{ $t('您的浏览器版本过低,请升级到最新版本后重试') }}
    </p>
    <p class="color-tips">
      {{ $t('浏览器要求:') }}
    </p>
    <p class="marb28">
      {{ $t('IE9及以上、IE edge、Chrome、Firefox4及以上、Safari5及以上、Opera11.5及以上') }}
    </p>
    <div class="footer">
      <button
        class="primary close"
        @click="iGotIt"
      >
        {{ $t('知道了') }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    iGotIt() {
      this.$emit('closeParentDialog')
    },
  },
}
</script>
<style lang="less">
@import '~less/ldtool-dialog.less';
</style>
